<template>
  <div class="row-fluid">
    <div class="mypull-right">
      <span
        v-if="canManageRicognizione"
        @click="saveRecog"
        data-original-title="Salva"
        class="fa-light fa-floppy-disk pulsante_comando js-tooltip"
      ></span>
      <span
        v-if="canManageRicognizione"
        @click="addRecogDetail"
        data-original-title="Nuovo"
        class="fa-light fa-plus pulsante_comando js-tooltip"
      ></span>
    </div>
    <h5 class="row-fluid" id="recog-title">QUALI FARMACI STA ASSUMENDO</h5>
    <table class="table table-hover table-striped">
      <thead>
        <tr class="heading">
          <td class="center text-uppercase" colspan="6">{{ i18nJS.ricognizione }}</td>
          <td class="center text-uppercase" colspan="4">{{ i18nJS.riconciliazione }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr class="heading">
          <td></td>
          <td>
            <span>NOME DEL FARMACO</span>
            <div style="font-size: 80%">(nome commerciale e/o denominazione del principio attivo)</div>
          </td>
          <td>{{ i18nJS.somm_form }}</td>
          <td>{{ i18nJS.somm_type }}</td>
          <td>Posologia</td>
          <td colspan="2">Ultima dose assunta (data/ora)</td>
          <td class="">Interrompi</td>
          <td class="">Conferma</td>
          <td class="">Modifica</td>
          <td>Modifica e commenti</td>
          <td></td>
        </tr>
      </thead>

      <tbody>
        <template v-for="(guestDrugsRecogDetail, index) in guestDrugsRecog.guest_drugs_recog_details">
          <tr
            v-if="!guestDrugsRecogDetail._destroy == 1"
            :key="index"
            :class="{
              interrupted: guestDrugsRecogDetail.stato_riconciliazione === 0,
              confirmed: guestDrugsRecogDetail.stato_riconciliazione === 1,
              modified: guestDrugsRecogDetail.stato_riconciliazione === 2,
              linked: !!guestDrugsRecogDetail.guest_drug_id,
            }"
          >
            <td class="center">
              <span
                v-if="canManageRicognizione"
                @click="removeRecogDetail(guestDrugsRecogDetail)"
                data-original-title="Elimina"
                class="cursor-pointer fa-light fa-trash js-tooltip"
              ></span>
            </td>
            <td>
              <autocomplete-input
                v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id"
                :ajax-url="drugsConfigsUrl"
                class="input-medium"
                v-model="guestDrugsRecogDetail.nome_farmaco"
              />
              <span v-else>{{ guestDrugsRecogDetail.nome_farmaco }}</span>
            </td>

            <td>
              <v-select2
                class="input-medium"
                v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id"
                :value="guestDrugsRecogDetail['somm_form']"
                :element_id.sync="guestDrugsRecogDetail['somm_form']"
                :element_description.sync="guestDrugsRecogDetail['somm_form_desc']"
                :options-list="sommFormOptions"
              />
              <span v-else>{{ guestDrugsRecogDetail.somm_form_desc }}</span>
            </td>
            <td>
              <v-select2
                class="input-medium"
                v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id"
                :value="guestDrugsRecogDetail['somm_type']"
                :element_id.sync="guestDrugsRecogDetail['somm_type']"
                :element_description.sync="guestDrugsRecogDetail['somm_type_desc']"
                :options-list="sommTypeOptions"
              />
              <span v-else>{{ guestDrugsRecogDetail.somm_type_desc }}</span>
            </td>
            <td>
              <input
                class="input-medium"
                v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id"
                type="text"
                v-model="guestDrugsRecogDetail.posologia"
              />
              <span v-else>{{ guestDrugsRecogDetail.posologia }}</span>
            </td>
            <td v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id">
              <datepicker
                :value="guestDrugsRecogDetail.data_ultima_assunzione"
                :placeholder="'Data'"
                @input="(val) => (guestDrugsRecogDetail.data_ultima_assunzione = val)"
              />
            </td>
            <td v-if="canManageRicognizione && !guestDrugsRecogDetail.guest_drug_id">
              <timepicker v-model="guestDrugsRecogDetail.ora_ultima_assunzione" class="input_time" :placeholder="'Ora'" />
            </td>
            <td v-else colspan="2">{{ guestDrugsRecogDetail.data_ora_ultima_assunzione }}</td>
            <td class="radio-riconc">
              <input
                v-if="canManageRiconciliazione && !guestDrugsRecogDetail.guest_drug_id"
                type="radio"
                v-model="guestDrugsRecogDetail.stato_riconciliazione"
                value="0"
              />
              <span v-else><i class="fa-solid fa-xmark red" v-if="guestDrugsRecogDetail.stato_riconciliazione === 0"></i></span>
            </td>
            <td class="radio-riconc">
              <input
                v-if="canManageRiconciliazione && !guestDrugsRecogDetail.guest_drug_id"
                type="radio"
                v-model="guestDrugsRecogDetail.stato_riconciliazione"
                value="1"
              />
              <span v-else
                ><i
                  class="fa-solid fa-check green"
                  v-if="guestDrugsRecogDetail.stato_riconciliazione === 1"
                  @click="addNewGuestDrug(guestDrugsRecogDetail)"
                ></i
              ></span>
            </td>
            <td class="radio-riconc">
              <input
                v-if="canManageRiconciliazione && !guestDrugsRecogDetail.guest_drug_id"
                type="radio"
                v-model="guestDrugsRecogDetail.stato_riconciliazione"
                value="2"
              />
              <span v-else
                ><i
                  class="fa-solid fa-check orange"
                  v-if="guestDrugsRecogDetail.stato_riconciliazione === 2"
                  @click="addNewGuestDrug(guestDrugsRecogDetail)"
                ></i
              ></span>
            </td>
            <td>
              <textarea
                rows="1"
                v-if="canManageRiconciliazione && !guestDrugsRecogDetail.guest_drug_id"
                v-model="guestDrugsRecogDetail.note_riconciliazione"
              />
              <span v-else>{{ guestDrugsRecogDetail.note_riconciliazione }}</span>
            </td>
            <td class="center">
              <span
                v-if="showGDAddBtn(guestDrugsRecogDetail)"
                @click="addNewGuestDrug(guestDrugsRecogDetail)"
                title="Aggiungi terapia"
                class="cursor-pointer fa-light fa-arrow-right-from-bracket js-tooltip"
              ></span>
              <span
                v-if="showGDEditBtn(guestDrugsRecogDetail)"
                @click="editGuestDrug(guestDrugsRecogDetail)"
                title="Modifica terapia"
                class="cursor-pointer fa-light fa-pen js-tooltip"
              ></span>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="mypull-right">
      <a
        v-if="guestDrugsRecog.id && guestDrugsRecog.versions_size > 0"
        data-toggle="modal"
        data-target="#modal-versions"
        data-skip-loader="true"
        :href="versionLink"
      >
        <i class="versions-icon fa-light fa-file-lines js-tooltip" tilte="Log modifiche">
          <span class="badge badge-info theme-bg">{{ guestDrugsRecog.versions_size }}</span>
        </i>
      </a>
      <span
        v-if="canManageRicognizione"
        @click="saveRecog"
        data-original-title="Salva"
        class="fa-light fa-floppy-disk pulsante_comando js-tooltip"
      ></span>
      <printlink v-if="guestDrugsRecog.id" :href="'/it/reports/generate_report'" :params="printData">
        <span class="fa-light fa-print pulsante_comando js-tooltip"></span>
      </printlink>
    </div>
    <h5 class="row-fluid" id="info-source-title">FONTE DELLE INFORMAZIONI</h5>
    <span v-if="canManageRicognizione">
      <div class="d-flex justify-content-between" id="info-source-wrapper">
        <div class="d-flex" v-for="(label, index) in infoRadio" :key="label.label">
          <label>
            <input type="radio" v-model="guestDrugsRecog.mezzo_fornisce_info" :value="index" />
            {{ label.label }}
            <input
              type="text"
              v-if="label.notes"
              v-show="guestDrugsRecog.mezzo_fornisce_info == index"
              v-model="guestDrugsRecog.mezzo_fornisce_info_notes"
            />
          </label>
        </div>
      </div>
    </span>
    <div class="row-fluid" v-else>
      {{ infoRadio[guestDrugsRecog.mezzo_fornisce_info].label }} {{ guestDrugsRecog.mezzo_fornisce_info_notes }}
    </div>
    <div class="row-fluid">
      <div class="span1">Fornite da</div>
      <div class="span2">
        <input v-if="canManageRicognizione" type="text" v-model="guestDrugsRecog.chi_fornisce_info" />
        <span v-else>{{ guestDrugsRecog.chi_fornisce_info }}</span>
      </div>
      <div class="span1">Note</div>
      <div class="span2">
        <input v-if="canManageRicognizione" type="text" v-model="guestDrugsRecog.chi_fornisce_info_notes" />
        <span v-else>{{ guestDrugsRecog.chi_fornisce_info_notes }}</span>
      </div>
    </div>

    <table class="table">
      <tr>
        <td></td>
        <td class="column-radio">Non noto</td>
        <td class="column-radio">No</td>
        <td class="column-radio">Sì</td>
        <td class="column-textarea">Specificare quali</td>
      </tr>
      <tr v-for="labelAndValue in labelsAndValues" :key="labelAndValue.value" class="recog-choice-row">
        <td>{{ labelAndValue.label }}</td>
        <td class="column-radio">
          <input v-if="canManageRicognizione" type="radio" v-model="guestDrugsRecog[labelAndValue.value]" value="0" />
          <span v-else><i class="fa-light fa-xmark" v-if="guestDrugsRecog[labelAndValue.value] === 0"></i></span>
        </td>
        <td class="column-radio">
          <input v-if="canManageRicognizione" type="radio" v-model="guestDrugsRecog[labelAndValue.value]" value="1" />
          <span v-else><i class="fa-light fa-xmark" v-if="guestDrugsRecog[labelAndValue.value] === 1"></i></span>
        </td>
        <td class="column-radio">
          <input v-if="canManageRicognizione" type="radio" v-model="guestDrugsRecog[labelAndValue.value]" value="2" />
          <span v-else><i class="fa-light fa-xmark" v-if="guestDrugsRecog[labelAndValue.value] === 2"></i></span>
        </td>
        <td class="column-textarea">
          <textarea
            v-if="canManageRicognizione && labelAndValue.notes"
            v-model="guestDrugsRecog[`${labelAndValue.value}_notes`]"
            v-show="guestDrugsRecog[labelAndValue.value] == 2"
          />
          <span v-else-if="labelAndValue.notes">{{ guestDrugsRecog[`${labelAndValue.value}_notes`] }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
import printlink from '../printlink';
import autocompleteInput from '../autocomplete/autocompleteInput';
import { LabelApi } from '@/epersonam/mixins/labels.js';

export default {
  name: 'guestDrugRecog',
  components: { vSelect2, datepicker, timepicker, printlink, autocompleteInput },
  mixins: [LabelApi],
  props: ['guestPeriodDataSetId', 'canManageRicognizione', 'canManageRiconciliazione', 'sommTypeOptions', 'sommFormOptions'],
  data() {
    return {
      tabLoaded: false,
      guestDrugsRecog: {},
      labelsAndValues: [
        { label: i18nJS.guest_drugs_recog.farmaci_offlabel, value: 'farmaci_offlabel', notes: true },
        { label: i18nJS.guest_drugs_recog.medicinali_omeopatici, value: 'medicinali_omeopatici', notes: true },
        { label: i18nJS.guest_drugs_recog.eventuali_reazioni_avverse, value: 'eventuali_reazioni_avverse', notes: true },
        { label: i18nJS.guest_drugs_recog.alimenti_interferenti, value: 'alimenti_interferenti', notes: true },
        { label: i18nJS.guest_drugs_recog.alcool_ecc, value: 'alcool_ecc', notes: true },
        { label: i18nJS.guest_drugs_recog.dispositivi_medici, value: 'dispositivi_medici', notes: true },
        { label: i18nJS.guest_drugs_recog.anticoagulanti, value: 'anticoagulanti', notes: false },
        { label: i18nJS.guest_drugs_recog.antidiabetici, value: 'antidiabetici', notes: false },
        { label: i18nJS.guest_drugs_recog.immunosoppressivi, value: 'immunosoppressivi', notes: false },
      ],
      infoRadio: [
        { label: i18nJS.guest_drugs_recog.verbale_paziente, notes: false },
        { label: i18nJS.guest_drugs_recog.verbale_familiare, notes: false },
        { label: i18nJS.guest_drugs_recog.doc_san, notes: false },
        { label: i18nJS.guest_drugs_recog.conf_farmaci, notes: false },
        { label: i18nJS.guest_drugs_recog.lista_pers, notes: false },
        { label: i18nJS.guest_drugs_recog.altro, notes: true },
        { label: i18nJS.guest_drugs_recog.nessuna, notes: false },
      ],
    };
  },
  async beforeMount() {
    this.neededlabels = [
      'command.undo',
      'guest_drugs_recog.farmaci_offlabel',
      'command.save',
      'description',
      'datein',
      'dateout',
      'notes',
      'ricognizione',
      'riconciliazione',
      'somm_type',
      'somm_form',
    ];
    await this.setupLabels();
  },
  mounted() {
    const tab = document.querySelector('#show-tab-recog');
    const li = tab.closest('li');
    if (li.classList.contains('active')) this.loadElements();
    $('#show-tab-recog').on('shown', () => {
      this.loadElements();
    });
  },
  watch: {},
  computed: {
    printData() {
      return {
        guest_period_data_set_id: this.guestPeriodDataSetId,
        type: 'PDF',
        worker: 'GuestDrugsRecogPdfWorker',
      };
    },
    versionLink() {
      return `/${window.locale}/versions/for/GuestDrugsRecog/${this.guestDrugsRecog.id}`;
    },
    drugsConfigsUrl() {
      return `/${window.locale}/drugs/autocomplete_drug_nome_commerciale.json?without_page=true`;
    },
  },
  methods: {
    loadElements() {
      if (this.tabLoaded) return;

      Loader.show();
      apiConnector()
        .get(`/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs_recogs/show_by_gpds`)
        .then(({ data }) => {
          this.guestDrugsRecog = data;
          Loader.hide();
          this.tabLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          Loader.hide();
        });
    },
    showGDAddBtn(guestDrugsRecogDetail) {
      return (
        this.canManageRiconciliazione &&
        !!guestDrugsRecogDetail.id &&
        !guestDrugsRecogDetail.guest_drug_id &&
        (guestDrugsRecogDetail.stato_riconciliazione === 1 || guestDrugsRecogDetail.stato_riconciliazione === 2)
      );
    },
    showGDEditBtn(guestDrugsRecogDetail) {
      return (
        this.canManageRiconciliazione &&
        !!guestDrugsRecogDetail.id &&
        !!guestDrugsRecogDetail.guest_drug_id &&
        (guestDrugsRecogDetail.stato_riconciliazione === 1 || guestDrugsRecogDetail.stato_riconciliazione === 2)
      );
    },
    addRecogDetail() {
      this.guestDrugsRecog.guest_drugs_recog_details.push({});
    },
    addNewGuestDrug(detail) {
      window.location.href = `/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs/new?anchor=tab0&description=${encodeURIComponent(detail.nome_farmaco)}&somm_form=${detail.somm_form}}&somm_type=${detail.somm_type}&guest_drugs_recog_detail_id=${detail.id}`;
    },
    editGuestDrug(detail) {
      window.location.href = `/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs/${detail.guest_drug_id}/edit?anchor=tab0`;
    },
    removeRecogDetail(detail) {
      if (detail.id) {
        Loader.show();
        const params = { guest_drugs_recog: { guest_durgs_recogs_attributes: { 0: detail } } };
        apiConnector()
          .delete(`/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs_recogs/destroy_detail/${detail.id}`)
          .then(() => {
            this.guestDrugsRecog.guest_drugs_recog_details = this.guestDrugsRecog.guest_drugs_recog_details.filter(
              (g) => g.id !== detail.id,
            );
            Loader.hide();
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } else {
        this.guestDrugsRecog.guest_drugs_recog_details = this.guestDrugsRecog.guest_drugs_recog_details.filter((g) => g !== detail);
      }
    },
    saveRecog() {
      let { guest_drugs_recog_details, ...params } = this.guestDrugsRecog;
      params['guest_drugs_recog_details_attributes'] = {};
      if (guest_drugs_recog_details) {
        guest_drugs_recog_details.forEach((detail, index) => {
          if (Object.keys(detail).length > 0 && detail.constructor === Object) {
            params['guest_drugs_recog_details_attributes'][index] = detail;
            if (!params['guest_drugs_recog_details_attributes'][index]['created_who'])
              params['guest_drugs_recog_details_attributes'][index]['created_who'] = window.userId;
            params['guest_drugs_recog_details_attributes'][index]['updated_who'] = window.userId;
          }
        });
      }
      Loader.show();
      if (this.guestDrugsRecog.id) {
        apiConnector()
          .patch(`/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs_recogs/${this.guestDrugsRecog.id}`, {
            guest_drugs_recog: params,
          })
          .then(({ data }) => {
            this.guestDrugsRecog = data;
            Loader.hide();
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } else {
        params['guest_period_data_set_id'] = this.guestPeriodDataSetId;
        apiConnector()
          .post(`/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_drugs_recogs`, { guest_drugs_recog: params })
          .then(({ data }) => {
            this.guestDrugsRecog = data;
            Loader.hide();
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
td.column-radio {
  width: 100px;
  text-align: center;
}

td.column-textarea {
  width: 300px;
}

.radio-riconc {
  width: 100px;
  text-align: center;
}

#info-source-title {
  height: 2em;
  line-height: 2em;
}

#info-source-wrapper {
  height: 3em;
  padding: 10px;
}

tr.recog-choice-row {
  background-color: inherit;

  &:hover {
    background-color: aliceblue;
  }
}

.bordered {
  //border-left: 1px solid #ccc;
}

.verticalTableHeader {
  text-align: center;
  white-space: nowrap;
  transform-origin: 50% 50%;
  transform: rotate(90deg);
  width: 100px;
}

.verticalTableHeader:before {
  content: '';
  padding-top: 110%; /* takes width as reference, + 10% for faking some extra padding */
  display: inline-block;
  vertical-align: middle;
}
</style>
